/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionUpdatePriceBody
 */
export interface SubscriptionUpdatePriceBody {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionUpdatePriceBody
     */
    priceId: string;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionUpdatePriceBody
     */
    isActive: boolean;
}

/**
 * Check if a given object implements the SubscriptionUpdatePriceBody interface.
 */
export function instanceOfSubscriptionUpdatePriceBody(value: object): value is SubscriptionUpdatePriceBody {
    if (!('priceId' in value) || value['priceId'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    return true;
}

export function SubscriptionUpdatePriceBodyFromJSON(json: any): SubscriptionUpdatePriceBody {
    return SubscriptionUpdatePriceBodyFromJSONTyped(json, false);
}

export function SubscriptionUpdatePriceBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionUpdatePriceBody {
    if (json == null) {
        return json;
    }
    return {
        
        'priceId': json['priceId'],
        'isActive': json['isActive'],
    };
}

export function SubscriptionUpdatePriceBodyToJSON(json: any): SubscriptionUpdatePriceBody {
    return SubscriptionUpdatePriceBodyToJSONTyped(json, false);
}

export function SubscriptionUpdatePriceBodyToJSONTyped(value?: SubscriptionUpdatePriceBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceId': value['priceId'],
        'isActive': value['isActive'],
    };
}

